import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewChecked, ViewChild } from '@angular/core';
import { currentSelectedBsk, getlistColumns, setinfoList, setResulProperty } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { BasketTools } from '@service/basket.tools';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { AuthService } from '@auth/auth.service';
import { DisplayResultComponent } from '@documalis/displayresult';
import { doc_name, doc_creationdate, doc_path, doc_size, doc_atfcount, reqBas } from '@documalis/_const/const';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'page-basket',
    styleUrls: ['./page-basket.component.scss'],
    templateUrl: './page-basket.component.html',
})
export class PageBasketComponent implements OnInit, OnDestroy, AfterViewChecked {
    public srchMode = reqBas;
    public resultDisplay: any[];
    public resultList: any[];
    public listColumns: any[];
    public selectedDocs: any[];
    public basketMoveAll: any[];
    public basket: any[];
    public title: string;
    public error = false;

    public index: number;
    public nbDoc = 0;
    public docIdList: any[];

    public actionGroup: boolean = false;
    public currentTransfertBsk: currentSelectedBsk;
    public infoList: any[];
    public curPage: number;
    public displayListResult = false;
    public isDesktop: boolean = false;
    public fetchParam: any;
    public userList: any[];

    @ViewChild('dispresult') public dispResult: DisplayResultComponent;

    constructor(
        private cdRef: ChangeDetectorRef,
        protected _messageService: MessagesService,
        private baskeList: BasketTools,
        private auth: AuthService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.resultDisplay = new Array();
        this.selectedDocs = new Array();
        this.docIdList = new Array();
        this.setResultList();
        this.fetchParam = {page: 1, displayNext: false};
    }

    public ngOnInit() {
        this.index = -1;
        this.listColumns = getlistColumns(this.resultList, this.translate);
        this.getBasketList();
        this.actionGroup = false;
        this.commonService.checkReset();
    }

    public ngOnDestroy() {
        this.fetchParam = null;
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    private getBasketList() {
        this.userList = [];
        this.title = this.getTitle(this.baskeList.basketList.length);
        this.init();
        this.resultDisplay = JSON.parse(JSON.stringify(this.baskeList.basketList));
        this.nbDoc = this.resultDisplay.length;
        this.curPage = 1;
        this.index = 1;

        this.infoList = setinfoList(this.resultList);
        if (this.infoList.length === 0) {
            this.infoList.push(doc_name);
            this.infoList[0].thumbinfo = 1;
        }
        if (this.baskeList.basketList.length !== 0) {
            this.getUserList();
        }
    }
    
    private async getUserList() {        
        try {
            await this.commonService.getUserList(this.userList);           
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private init() {
        this.basket = null;
        this.infoList = null;
    }

    private getTitle(aNbDoc) {
        if (aNbDoc === 0) {
            return this.translate.instant('Emp_Bask');
        } else {
            return this.translate.instant('Cnt_Bask');
        }
    }

    public handleChange($event) {}

    public returnList() {
        this.displayListResult = false;
        this.dispResult.goResultDoc();
    }

    public onReturnResult(event) {
        this.displayListResult = true;
    }

    public onAction(event) {
        if (event === 'del') {
            this.title = this.getTitle(this.baskeList.basketList.length);
        }
    }

    public onNextDocs() {}

    private setResultList() {
        this.resultList = [];
        this.resultList.push(doc_atfcount);
        this.resultList.push(doc_name);
        this.resultList.push(doc_creationdate);
        this.resultList.push(doc_size);
        this.resultList.push(doc_path);
        setResulProperty(this.resultList, doc_name.name, 'thumbinfo', 1);
    }
}
